"use strict";

angular.module("vendor")
.directive("marketTargeting", function() {
    return {
        controllerAs: "marketTargetingCtrl",
        templateUrl: require("./market.directive.html"),
        scope: true,
        bindToController: {
            hideTitle: "<?",
            hideActionButtons: "<?",
            zones: "=?",
            refreshFunction: "&?",
            referenceType: "@?",
            referenceId: "<?",
            onZoneKeyChangeFunction: "<?",
            catalogSharing: "<?",
            hasError: "<?",
            required: "<?"
        },
        controller: function($scope, $http, ZoneService, common, FlashBag, appConfig) {
            var _this = this;

            this.zones = this.zones || [];

            $scope.$watch(function() {
                return _this.referenceId;
            }, function(newVal) {
                // will only be call one time at load
                if (newVal && _this.referenceId) {
                    _this.loadZones();
                }
            });

            $scope.$watch("language", function(newVal, oldVal) {
                // if the change is not really one && the synchronisation with the first load occurs
                if (oldVal !== newVal && _this.referenceId) {
                    _this.retrieveZones(_this.makeZonesKey());
                }
            });

            this.placeSelected = null;
            this.autoCompleteOptions = {
                minimumChars: 1,
                data: function(term) {
                    if (!term || term === "") {
                        return;
                    }

                    return $http({
                        url: appConfig.API_SERVER + "/market/locations/get/",
                        method: "POST",
                        headers: {"Content-Type": "application/x-www-form-urlencoded"},
                        data: $.param({
                            text: term
                        })
                    }).then(
                        function onSuccess(response) {
                            return response.data;
                        },
                        function onError() {
                            return null;
                        })
                },
                itemTemplateUrl: require("./market-item.directive.html"),
                itemSelected: function(obj) {
                    if (!isZoneExists(obj)) {
                        _this.zones.push(obj.item);
                        _this.zones.isDirty = true;

                        updateOnChange();
                    }

                    _this.placeSelected = "";
                }
            };

            function isZoneExists(obj) {
                return _this.zones.filter(function(zone) {
                    return zone.id === obj.item.id;
                }).length
            }

            this.removeZone = function(item) {
                var pos = this.zones.indexOf(item);
                this.zones.splice(pos, 1);
                this.zones.isDirty = true;
                $scope.isZonesNotExist = this.zones.length === 0;

                updateOnChange();
            };

            this.retrieveZones = function(zonesKey) {
                ZoneService.retrieveZones(zonesKey).then(
                    function onSuccess(response) {
                        _this.zones = response.data;
                        _this.zones.isDirty = false;

                        updateOnChange();
                    },
                    function onError() {
                        _this.setDefaultValue();
                    }
                );
            };

            this.loadZones = function() {
                if (this.referenceId === undefined || this.referenceType === undefined) {
                    return;
                }

                $http({
                    url: appConfig.API_SERVER + "/market/zones/get/",
                    method: "POST",
                    headers: {"Content-Type": "application/x-www-form-urlencoded"},
                    data: $.param({
                        refID: this.referenceId,
                        refType: this.referenceType
                    })
                }).then(
                    function onSuccess(response) {
                        if (response.status === 200) {
                            _this.retrieveZones(response.data);
                        }
                        else if (response.status === 205) {
                            _this.setDefaultValue();
                        }
                    },
                    function onError() {
                        _this.setDefaultValue();
                    }
                );
            };

            this.makeZonesKey = function() {
                var key = "";
                if (this.zones) {
                    for (var i = 0; i !== this.zones.length; i++) {
                        key += this.zones[i].id + ";";
                    }
                    key = key.slice(0, -1);
                }

                return key;
            };

            this.setDefaultValue = function() {
                this.zones = [];
                this.zones.isDirty = false;
                $scope.isZonesNotExist = true;

                updateOnChange();
            };

            this.save = function() {
                var zones = this.makeZonesKey();
                var url = "/market/zones/save/";

                if (this.catalogSharing) {
                    url = "/catalog/save-zones/";
                }

                $http({
                    url: appConfig.API_SERVER + url,
                    method: "POST",
                    headers: {"Content-Type": "application/x-www-form-urlencoded"},
                    data: $.param({
                        refID: this.referenceId,
                        refType: this.referenceType,
                        zonesKey: zones
                    })
                }).then(
                    function onSuccess() {
                        _this.zones.isDirty = false;
                    },
                    function onError(response) {
                        if (response.status === 403 && response.data['detail'] !== undefined) {
                            FlashBag.alertWithContainer("danger", "flash-catalog", response.data['detail']);
                            common.scrollToTop();
                        }
                    }
                ).finally(
                    function() {
                        $scope.$emit("market.directive.refreshFunction", _this.referenceType, zones);
                        if (_this.refreshFunction !== undefined) {
                            _this.refreshFunction();
                        }
                    }
                );
            };

            function updateOnChange() {
                if (_this.onZoneKeyChangeFunction === undefined) {
                    return;
                }
                var zoneKeys = _this.makeZonesKey();
                _this.onZoneKeyChangeFunction(zoneKeys);
            }

        }
    };
});



//////////////////
// WEBPACK FOOTER
// ./vendor/app-core/market/market.directive.js
// module id = 822
// module chunks = 0